export default "<mat-card>Simple card</mat-card>";